import { IPredictedLineupsDetail, ITeamTypings, PlayerTypings } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidMatchPredictedLineups } from './typeguards';
import { CreatePredictedLineupDetailsInputSchema, PredictedLineupPlayerList, PredictedLineupTeam } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { MatchPredictedLineupsQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';
import { transformFormationFields } from '../../../utils/formation/formation';
import { IGenericObject } from '../../../utils/tests';

export const stringToObjectArray = (fullName: string, _isArray: boolean = true) => {
  const player: PlayerTypings.IPlayer = {
    id: null,
    role: null,
    fullName,
  };

  return player;
};

const transformTeam = (team: PredictedLineupTeam): ITeamTypings => {
  const { playerList } = team;
  const { disqualifiedPlayers, manager, potentialPlayers, substitutePlayers, unavailablePlayers, predictedLineup } =
    playerList as PredictedLineupPlayerList;
  return {
    ctaUrl: team.predictedTeamLink ?? '',
    formation: team.formation as ITeamTypings['formation'],
    id: team.id,
    logoUrl: team.negativeLogoUrl || team.logo!,
    name: team.customName!,
    seoName: team.customSeoName ?? undefined,
    shortname: team.teamShortName ?? undefined,
    playerList: {
      disqualifieds: [stringToObjectArray(disqualifiedPlayers!)],
      manager: stringToObjectArray(manager!),
      potentialPlayers: [stringToObjectArray(potentialPlayers!)],
      substitutes: [stringToObjectArray(substitutePlayers!)],
      unavailables: [stringToObjectArray(unavailablePlayers!)],
      startingLineup: predictedLineup!.map((item) => ({
        ...item,
        fullName: item!.fullName,
      })) as PlayerTypings.IPlayer[],
    },
  };
};

export default (obj: MatchPredictedLineupsQuery): IPredictedLineupsDetail=> {
  if (isValidMatchPredictedLineups(obj)) {
    CreatePredictedLineupDetailsInputSchema().parse(obj.data.matchPredictedLineup, {reportInput: true});

    const { matchPredictedLineup } = obj?.data!;

      const {
        matchData,
        competitionId,
        teamId,
        predictedHpLink: ctaHpUrl,
        predictedSponsorLink,
        hasHeadshots,
      } = matchPredictedLineup;
      const { away, home, date, lmpLineupLink: ctaLmpLineupUrl, lmpLink: ctaLmpUrl } = matchData!;
      const playersInFormation: IGenericObject = transformFormationFields({
        away: transformTeam(away!),
        home: transformTeam(home!),
      });

      const transformed: IPredictedLineupsDetail = {
        hasImage: hasHeadshots!,
        date: date!,
        competitionId,
        teamId,
        ctaHpUrl,
        ctaLmpUrl,
        ctaLmpLineupUrl,
        away: {
          ...transformTeam(away!),
          playersInFormation: playersInFormation?.away?.players ?? [],
        },
        home: {
          ...transformTeam(home!),
          playersInFormation: playersInFormation?.home?.players ?? [],
        },
        trackingData: intcmpMap.matchPredictedLineups,
        predictedSponsorLink: predictedSponsorLink || '',
      };

      return transformed;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchPredictedLineupsQuery object',
      data: obj
    });
  }
};
